import store, { injectReducer } from './core/configureStore'; // _platform

export default store;
export { injectReducer };
